import { ListItem, Text, UnorderedList, VStack } from '@chakra-ui/react'
import { PopUpMessageContext, useAuth } from '@hb/react'
import { useCallback, useContext } from 'react'
import { deleteAccountFunction } from '../../backend/functions/other'
import { useNavigate } from '../../hooks/navigation'
import { DeleteButton } from '../Buttons/DeleteButton'
import { PageHeader } from '../Header'
import { InfoBox, InfoHeader, InfoText } from '../Info'
import { PageContainer } from './PageContainer'

const DeleteAccountWarning = () => (
  <VStack align="flex-start" spacing={2}>
    <InfoHeader>Your account and the following data will be permanently deleted:</InfoHeader>
    <UnorderedList pl={4} spacing={1}>
      <ListItem>
        <InfoText as="span">Contact info and profile data</InfoText>
      </ListItem>
      <ListItem>
        <InfoText as="span">Pregnancies and associated health records</InfoText>
      </ListItem>
      <ListItem>
        <InfoText as="span">Uploaded files and documents</InfoText>
      </ListItem>
      <ListItem>
        <InfoText as="span">Consent forms</InfoText>
      </ListItem>
    </UnorderedList>
    <Text fontFamily="Open Sans" fontWeight={500} fontSize={['md', 'lg']} px={3} color="gray.600">
      Chat messages will not be deleted but will be anonymized.
    </Text>
    <Text fontFamily="Open Sans" fontWeight={600} fontSize={['md', 'lg']} px={3} color="red.600">
      This action cannot be undone.
    </Text>
  </VStack>
)

export const DeleteAccountView = () => {
  const { authUser } = useAuth()
  const navigate = useNavigate()
  const { showError } = useContext(PopUpMessageContext)

  const handleDelete = useCallback(async () => {
    try {
      await deleteAccountFunction()
      navigate('/')
    } catch (err: any) {
      showError(err?.message ?? 'Failed to delete account. Please try again.')
    }
  }, [navigate, showError])

  if (!authUser) {
    return (
      <PageContainer>
        <PageHeader mt={6}>DELETE ACCOUNT</PageHeader>
        <InfoBox mt={6}>
          <InfoText>You must be signed in to delete your account.</InfoText>
        </InfoBox>
      </PageContainer>
    )
  }

  return (
    <PageContainer>
      <PageHeader mt={6}>DELETE ACCOUNT</PageHeader>
      <InfoBox mt={6} maxW="600px" w="100%" borderRadius={8} p={6}>
        <DeleteAccountWarning />
        <DeleteButton
          onDelete={handleDelete}
          itemName="account"
          actionName="Delete"
          text="Delete My Account"
          alertBody={<DeleteAccountWarning />}
          mt={2}
          size="md"
        />
      </InfoBox>
    </PageContainer>
  )
}
